import React from 'react';
import { Link } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

const Main = () => {
 return (
  <div>
   <Link to="/ej">Home</Link> <Link to="tarea">Company</Link> <Link to="list">Lista</Link> <Outlet />
  </div>
 );
};

export default Main;
